// @flow

import { observer } from "mobx-react";
import React from "react";

import HtmlAudio from "app/components/HtmlAudio/HtmlAudio";

import "./AudioFilePreview.scss";

type Props = {
    file: File
};

type State = {
    data?: string
};

@observer
export default class VideoFilePreview extends React.Component<
    Props,
    State
> {
    reader: FileReader;

    static types: { [string]: Function } = {};

    static pushType(type: string, component: Function) {
        this.types[type] = component;
    }

    constructor(props: Props) {
        super(props);
        this.state = { data: "" };

        this.reader = new FileReader();
        this.reader.onload = (event: any) =>
            this.setState({ data: event.target.result });

        this.readFile(this.props.file);
    }

    readFile(file: File) {
        this.reader.readAsDataURL(file);
    }

    componentWillReceiveProps(props: Props) {
        this.readFile(props.file);
    }

    render() {
        if (!this.state.data) {
            return null;
        }

        return <HtmlAudio src={this.state.data} />;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/FilePreview/AudioFilePreview/AudioFilePreview.js